import React, {PropTypes} from 'react';
import CaptainPaymentEntryListItemContainer from './CaptainPaymentEntryListItemContainer.jsx';
import CaptainPaymentVirtualEventListItemContainer from './CaptainPaymentVirtualEventListItemContainer.jsx';

const CaptainPaymentEntryList = ({
  paymentEntries,
  paymentVirtualEvents
}) => (
  <div className="list-group">
    {paymentEntries.length
      ? paymentEntries.map((paymentEntry, index) => (
          <div className="animated fadeIn"
               key={index}>
            <CaptainPaymentEntryListItemContainer {...paymentEntry} />
          </div>
        ))
      : null
    }
    {paymentVirtualEvents.length
      ? paymentVirtualEvents.map((paymentVirtualEvent, index) => (
          <div className="animated fadeIn"
               key={index}>
            <CaptainPaymentVirtualEventListItemContainer {...paymentVirtualEvent} />
          </div>
        ))
      : null
    }
  </div>
);

CaptainPaymentEntryList.propTypes = {
  paymentEntries: PropTypes.arrayOf(PropTypes.object),
  paymentVirtualEvents: PropTypes.arrayOf(PropTypes.object)
};

CaptainPaymentEntryList.defaultProps = {
  paymentEntries: [],
  paymentVirtualEvents: []
};

export default CaptainPaymentEntryList;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainPaymentEntryList.jsx